import { render, staticRenderFns } from "./UserTel.vue?vue&type=template&id=7af09f90&scoped=true&"
import script from "./UserTel.vue?vue&type=script&lang=js&"
export * from "./UserTel.vue?vue&type=script&lang=js&"
import style0 from "./UserTel.vue?vue&type=style&index=0&id=7af09f90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af09f90",
  null
  
)

export default component.exports